import React from 'react';
import { Section } from './ui/Section';
export function ObjectionsSection() {
  const faqs = [{
    q: '¿Y si mi papá/mamá es terco/a?',
    a: 'Justamente. Este método trabaja con el orgullo y la autoridad sin chocar de frente: pide permiso, reduce presión y cambia el marco de la conversación.'
  }, {
    q: '¿Y si ya intenté hablar mil veces?',
    a: 'Porque hablaste con el mismo código. Aquí cambias el idioma, no el tema. Cuando cambias la forma, la respuesta cambia.'
  }, {
    q: 'No tengo tiempo.',
    a: 'El plan es de micro-acciones: mensajes cortos, llamadas de 8 minutos, y rutinas simples. No necesitas horas de charla profunda.'
  }];
  return <Section background="stone" data-id="element-120">
      <h2 className="text-2xl md:text-3xl font-serif font-bold text-stone-900 text-center mb-8" data-id="element-121">
        Preguntas frecuentes
      </h2>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-122">
        {faqs.map((faq, i) => <div key={i} className="bg-white rounded-xl p-5 shadow-sm" data-id="element-123">
            <h3 className="font-bold text-stone-900 text-base mb-2 flex items-start gap-2" data-id="element-124">
              <span className="text-orange-600" data-id="element-125">?</span> {faq.q}
            </h3>
            <p className="text-stone-600 text-sm pl-5 border-l-2 border-stone-100" data-id="element-126">
              {faq.a}
            </p>
          </div>)}
      </div>
    </Section>;
}